import { render, staticRenderFns } from "./EditCongressEditionList.vue?vue&type=template&id=4bc1a872"
import script from "./EditCongressEditionList.vue?vue&type=script&lang=js"
export * from "./EditCongressEditionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports